import { render, staticRenderFns } from "./commentItem.vue?vue&type=template&id=397e91fc&"
import script from "./commentItem.vue?vue&type=script&lang=ts&"
export * from "./commentItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports